import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { connect } from 'react-redux';
import Subsection from 'settings-ui-lib/components/Subsection';
import SettingsRowButton from 'settings-ui-lib/components/SettingsRowButton';
import { toggleLogOutAllSessionsModalOpen as toggleLogOutAllSessionsModalOpenAction } from '../actions/AppActions';
import LogOutAllSessionsModalContainer from './LogOutAllSessionsModalContainer';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LogOutAllSessionsContainer = ({
  toggleLogOutAllSessionsModalOpen
}) => /*#__PURE__*/_jsxs(Subsection, {
  title: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "userPreferences.logOutAllSessions.title"
  }),
  children: [/*#__PURE__*/_jsx(SettingsRowButton, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "userPreferences.logOutAllSessions.button"
    }),
    onClick: toggleLogOutAllSessionsModalOpen,
    description: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "userPreferences.logOutAllSessions.description"
    })
  }), /*#__PURE__*/_jsx(LogOutAllSessionsModalContainer, {})]
});
LogOutAllSessionsContainer.propTypes = {
  toggleLogOutAllSessionsModalOpen: PropTypes.func.isRequired
};
export default connect(null, {
  toggleLogOutAllSessionsModalOpen: toggleLogOutAllSessionsModalOpenAction
})(LogOutAllSessionsContainer);